import { translate } from '@/mixins/translate';
const { $$t } = translate('_web_tournaments_battle-royale').methods; // do not use as mixin

export default {
  methods: {
    roundName(rounds, index) {
      const $t = $$t.bind(this);
      return $t('#{num}', 'round', { num: index + 1 });
    },
  },
};
